// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"c4maM","ico":"HElGM","title":"_1hcU3","id":"_2y-i5"};